import { OLD_OUTAGES_ACTIONS } from '../actions/oldOutagesActions';

// ─── INITIAL STATE ─────────────────────────────────────────────────────────────
const initialState = {
	loading: {
		importFile:                  false,
		lastUpdate:                  false,
		completionOverdue:           false,
		endingToday:                 false,
		partnerRestricted:           false,
		partnerRestrictedBlacklist:  false,
		partnersEmails:              false,
	},
	lastUpdate: {
		user:      null,
		timestamp: null,
	},
	error: null,
};

// ─── REDUCER ──────────────────────────────────────────────────────────────────
const OldOutagesReducer = (state = initialState, action) => {
	switch (action.type) {

					// ── Import File ────────────────────────────────────────────────────────────
					case OLD_OUTAGES_ACTIONS.OO_IMPORT_REQUEST:
						return { ...state, loading: { ...state.loading, importFile: true }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_IMPORT_SUCCESS:
						return { ...state, loading: { ...state.loading, importFile: false }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_IMPORT_FAILURE:
						return { ...state, loading: { ...state.loading, importFile: false }, error: action.error };

						// ── Get Last Update ────────────────────────────────────────────────────────
					case OLD_OUTAGES_ACTIONS.OO_GET_LAST_UPDATE_REQUEST:
						return { ...state, loading: { ...state.loading, lastUpdate: true } };

					case OLD_OUTAGES_ACTIONS.OO_GET_LAST_UPDATE_SUCCESS:
						return { ...state, loading: { ...state.loading, lastUpdate: false }, lastUpdate: action.payload, error: null };

					case OLD_OUTAGES_ACTIONS.OO_GET_LAST_UPDATE_FAILURE:
						return { ...state, loading: { ...state.loading, lastUpdate: false }, error: action.error };

						// ── Completion Overdue ─────────────────────────────────────────────────────
					case OLD_OUTAGES_ACTIONS.OO_COMPLETION_OVERDUE_REQUEST:
						return { ...state, loading: { ...state.loading, completionOverdue: true }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_COMPLETION_OVERDUE_SUCCESS:
						return { ...state, loading: { ...state.loading, completionOverdue: false }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_COMPLETION_OVERDUE_FAILURE:
						return { ...state, loading: { ...state.loading, completionOverdue: false }, error: action.error };

						// ── Ending Today ───────────────────────────────────────────────────────────
					case OLD_OUTAGES_ACTIONS.OO_ENDING_TODAY_REQUEST:
						return { ...state, loading: { ...state.loading, endingToday: true }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_ENDING_TODAY_SUCCESS:
						return { ...state, loading: { ...state.loading, endingToday: false }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_ENDING_TODAY_FAILURE:
						return { ...state, loading: { ...state.loading, endingToday: false }, error: action.error };

						// ── Partner Restricted ─────────────────────────────────────────────────────
					case OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_REQUEST:
						return { ...state, loading: { ...state.loading, partnerRestricted: true }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_SUCCESS:
						return { ...state, loading: { ...state.loading, partnerRestricted: false }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_FAILURE:
						return { ...state, loading: { ...state.loading, partnerRestricted: false }, error: action.error };

						// ── Partner Restricted Blacklist ───────────────────────────────────────────
					case OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_BLACKLIST_REQUEST:
						return { ...state, loading: { ...state.loading, partnerRestrictedBlacklist: true }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_BLACKLIST_SUCCESS:
						return { ...state, loading: { ...state.loading, partnerRestrictedBlacklist: false }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_PARTNER_RESTRICTED_BLACKLIST_FAILURE:
						return { ...state, loading: { ...state.loading, partnerRestrictedBlacklist: false }, error: action.error };

						// ── Partners Emails ────────────────────────────────────────────────────────
					case OLD_OUTAGES_ACTIONS.OO_PARTNERS_EMAILS_REQUEST:
						return { ...state, loading: { ...state.loading, partnersEmails: true }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_PARTNERS_EMAILS_SUCCESS:
						return { ...state, loading: { ...state.loading, partnersEmails: false }, error: null };

					case OLD_OUTAGES_ACTIONS.OO_PARTNERS_EMAILS_FAILURE:
						return { ...state, loading: { ...state.loading, partnersEmails: false }, error: action.error };

					default:
						return state;
	}
};

export default OldOutagesReducer;